const config=
{
    url:"https://mern-sdp-30.onrender.com"
};
export default config;